const formatTelURI = (input: string | String): string => {
  // Extract all digits from the input
  const allDigits = input.trim().replace(/\D/g, '');

  // If starts with '1' and 11+ digits, treat first 11 as number
  // Else if 10+ digits, treat first 10 as number
  let baseNumber = '';
  let extension = '';

  if (allDigits.length >= 11 && allDigits.startsWith('1')) {
    baseNumber = allDigits.slice(0, 11);
    extension = allDigits.slice(11);
  } else if (allDigits.length >= 10) {
    baseNumber = '1' + allDigits.slice(0, 10);
    extension = allDigits.slice(10);
  } else {
    // fallback for too-short input
    baseNumber = allDigits;
  }

  // Build tel URI using semicolon to indicate a "wait" before extension
  return extension ? `tel:+${baseNumber};${extension}` : `tel:+${baseNumber}`;
};

export default formatTelURI;
